import styled, { css, keyframes } from 'styled-components'

import { TransitionPrimary } from '@/lib/mixins'

export const PointerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${props => props.theme.color.primary};
  ${TransitionPrimary('opacity')};

  ${props =>
    props.theme.accessibilityMode &&
    css`
      flex-direction: row;
    `};

  ${props =>
    props.theme.contrastMode &&
    css`
      color: ${props.theme.color.global};
    `};
`

export const PointerText = styled.div`
  margin-bottom: 1rem;
  font-weight: 600;

  ${props =>
    props.theme.accessibilityMode &&
    css`
      margin-right: 1rem;
      margin-bottom: 0;
    `}
`

const pointerAnimation = keyframes`
  0% {
    transform: translateY(0);
    opacity: 0;
  }
  50% {
    transform: translateY(1.5rem);
    opacity: 1;
  }
  100% {
    transform: translateY(3rem);
    opacity: 0;
  }`

export const PointerIcon = styled.div`
  position: relative;
  width: 3rem;
  height: 4rem;

  svg {
    position: absolute;
    left: 0;
    width: 100%;
    top: 0;
    fill: currentColor;
    animation: ${pointerAnimation} 2s infinite linear;
    opacity: 0;

    &:nth-child(2) {
      animation-delay: 1s;
    }
  }
`
